<div #text class="ui-badge__text">
    <ng-content></ng-content>
</div>

